import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const c = t((e, r) => /* @__PURE__ */ o.jsx(
  i,
  {
    ref: r,
    ...e,
    image: (s) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: [
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M8 0C3.59 0 0 3.59 0 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m0 14.5c-3.58 0-6.5-2.92-6.5-6.5S4.42 1.5 8 1.5s6.5 2.92 6.5 6.5-2.92 6.5-6.5 6.5"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M11.7 7.25H4.3c-.41 0-.75.34-.75.75s.34.75.75.75h7.39c.41 0 .75-.34.75-.75s-.33-.75-.74-.75"
            }
          )
        ]
      }
    )
  }
));
c.displayName = "AgencyCircleRemoveIcon";
export {
  c as AgencyCircleRemoveIcon,
  c as default
};
//# sourceMappingURL=index.js.map
